import React, { useState, useEffect } from 'react';
import Button from '../../../shared/components/ui/Button';
import { useForm } from 'react-hook-form';
import { getAllUsers } from '../../services/api/implementation/impl';
import { useQuery } from '@tanstack/react-query';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import toast from 'react-hot-toast';

export const ReportAdmin = () => {
  const [reportType, setReportType] = useState('builder');
  const { register, handleSubmit } = useForm();
  const [selectedBuilder, setSelectedBuilder] = useState('');
  const userId = Cookies.get('userId');

  // Track component view
  useEffect(() => {
    mixpanel.track('Super Admin Report Admin Form Viewed', {
      user_id: userId,
      default_report_type: reportType,
      timestamp: new Date().toISOString()
    });
  }, [userId, reportType]);

  const { data: users } = useQuery({
    queryKey: ['users'],
    queryFn: () => getAllUsers(),
    onSuccess: (result) => {
      // Check if result is an error object
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        mixpanel.track('Super Admin Report Users Data Fetch Failed', {
          user_id: userId,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        toast.error(result?.response?.data?.message || result?.message || 'Failed to fetch users');
        return;
      }

      mixpanel.track('Super Admin Report Users Data Fetch Success', {
        user_id: userId,
        users_count: result?.length || 0,
        timestamp: new Date().toISOString()
      });
    },
    onError: (err) => {
      mixpanel.track('Super Admin Report Users Data Fetch Failed', {
        user_id: userId,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
      toast.error(err?.response?.data?.message || err?.message || 'Failed to fetch users');
    }
  });

  const handleBuilderChange = (e) => {
    const builderId = e.target.value;
    const selectedUser = users?.find((user) => user.id === parseInt(builderId));

    mixpanel.track('Super Admin Report Builder Selected', {
      user_id: userId,
      selected_builder_id: builderId,
      selected_builder_name: selectedUser?.primery_user?.name,
      timestamp: new Date().toISOString()
    });

    setSelectedBuilder(builderId);
  };

  const handleDownloadReport = () => {
    const selectedUser = users?.find((user) => user.id === parseInt(selectedBuilder));

    mixpanel.track('Super Admin Report Download Initiated', {
      user_id: userId,
      report_type: reportType,
      selected_builder_id: selectedBuilder,
      selected_builder_name: selectedUser?.primery_user?.name || 'None',
      has_builder_selected: !!selectedBuilder,
      timestamp: new Date().toISOString()
    });

    if (!selectedBuilder) {
      toast.error('Please select a builder before downloading the report');
      mixpanel.track('Super Admin Report Download Failed', {
        user_id: userId,
        error_reason: 'no_builder_selected',
        timestamp: new Date().toISOString()
      });
      return;
    }

    // Add your actual download logic here
    toast.success('Report download started');
    mixpanel.track('Super Admin Report Download Success', {
      user_id: userId,
      report_type: reportType,
      selected_builder_id: selectedBuilder,
      selected_builder_name: selectedUser?.primery_user?.name,
      timestamp: new Date().toISOString()
    });
  };

  const transformedBuilders = users?.map((item) => ({
    value: item?.id,
    label: item?.primery_user?.name?.trim()
  }));

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow">
      <div className="mb-8"></div>

      <div className="space-y-6">
        <div className="flex flex-col">
          <label className="block text-sm font-medium text-gray-700 mb-1">Builder Name</label>
          <select
            className="mt-1 block w-full px-3 py-2 rounded-md border border-gray-300 
                                 bg-white shadow-sm transition-colors duration-200
                                 hover:bg-[#2a575d] hover:bg-opacity-10 hover:border-[#2a575d]
                                 focus:border-[#2a575d] focus:outline-none focus:ring-1 focus:ring-[#2a575d]"
            value={selectedBuilder}
            onChange={handleBuilderChange}>
            <option value="">Select builder</option>
            {transformedBuilders?.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>

        <div className="flex justify-center">
          <button
            className="px-4 py-2 bg-[#2a575d] text-white rounded-md 
                                 hover:bg-[#234448] focus:outline-none focus:ring-2 
                                 focus:ring-[#2a575d] focus:ring-offset-2 
                                 transition-colors duration-200"
            onClick={handleDownloadReport}>
            Download {reportType === 'leads' ? '' : 'Builder'} Report
          </button>
        </div>
      </div>
    </div>
  );
};
